// "1 miss", "2 misses", "1 day", "3 days"
export const plural = (n, w) => `${n} ${n === 1 ? w : /(s|x|z|ch|sh)$/.test(w) ? `${w}es` : `${w}s`}`;
